module.exports = __webpack_public_path__ + "static/media/file_copy.fca12169.svg";